import React, { useEffect, useRef, useState } from 'react';

type TypewriterMessageProps = {
    text: string;
    keyWordDelay?: number; // optional if you want a default
};
const TypewriterMessage: React.FC<TypewriterMessageProps> = ({ text, keyWordDelay }) => {
    const [displayedText, setDisplayedText] = useState('');
    const hasAnimated = useRef(false);  // To avoid running the animation again if the text doesn't change
    useEffect(() => {
        if (hasAnimated.current) {
            setDisplayedText(text);
            // setShowCursor(false);
            return;
        }
        let i = 0;
        const interval = setInterval(() => {
            if (i < text.length) {
                const currentChar = text[i];
                if (currentChar !== undefined) {
                    setDisplayedText((prev) => prev + currentChar);
                } else {
                    console.error(`Unexpected undefined at index ${i}.`);
                }

                i++;
            } else {
                clearInterval(interval);
                hasAnimated.current = true;
                // setShowCursor(false);  // Hide the cursor after typing is done
            }
        }, keyWordDelay);

        return () => clearInterval(interval); // Cleanup the interval on unmount
    }, [text]);

    return (
        <>
            <span
                style={{
                    fontFamily: "Lato, sans-serif" ,
                    fontWeight: 600,
                    fontSize: '18px',
                    color: '#020742',
                }}
            >
                {displayedText || '\u00A0'} {/* Ensure there's no empty space or undefined */}
            </span>
            {/* {showCursor && <span className="blinking-cursor">|</span>} */}
        </>
    );
};

export default TypewriterMessage;
